import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { LoadingSpinner } from "@/components/ui/loading-spinner";

type PatronProfileCardProps = {
  email: string;
  firstName: string;
  lastName: string;
  phone: string;
  saving: boolean;
  onFirstNameChange: (value: string) => void;
  onLastNameChange: (value: string) => void;
  onPhoneChange: (value: string) => void;
  onSave: () => void;
};

export function PatronProfileCard({
  email,
  firstName,
  lastName,
  phone,
  saving,
  onFirstNameChange,
  onLastNameChange,
  onPhoneChange,
  onSave,
}: PatronProfileCardProps) {
  return (
    <Card className="border-slate-200 shadow-sm">
      <CardHeader className="pb-3">
        <CardTitle className="text-base">Profile</CardTitle>
        <p className="text-sm text-slate-500">Update the name and phone used on this account.</p>
      </CardHeader>
      <CardContent className="space-y-4">
        <div className="grid gap-4 sm:grid-cols-2">
          <div className="space-y-1.5">
            <Label htmlFor="patron-first-name">First name</Label>
            <Input
              id="patron-first-name"
              value={firstName}
              onChange={(e) => onFirstNameChange(e.target.value)}
            />
          </div>
          <div className="space-y-1.5">
            <Label htmlFor="patron-last-name">Last name</Label>
            <Input
              id="patron-last-name"
              value={lastName}
              onChange={(e) => onLastNameChange(e.target.value)}
            />
          </div>
        </div>
        <div className="space-y-1.5">
          <Label htmlFor="patron-phone">Phone</Label>
          <Input id="patron-phone" value={phone} onChange={(e) => onPhoneChange(e.target.value)} />
        </div>
        <p className="text-xs text-slate-500">
          Email <span className="font-medium text-slate-700">{email}</span> is not editable here.
        </p>
        <Button onClick={onSave} disabled={saving}>
          {saving ? <LoadingSpinner size="sm" /> : "Save profile"}
        </Button>
      </CardContent>
    </Card>
  );
}
